import { useState, useEffect } from "react"
import { Wrapper } from "@googlemaps/react-wrapper"

import { useUI } from "providers/UIProvider"

import { TBILISI_COORDINATES } from "utils/constants"

import { Box, Flex } from "@chakra-ui/react"

import Map from "./Map"
import Marker from "./Marker"
import Button from "components/UI/atoms/Button"

import { IGoogleMapProps } from "./GoogleMapTypes"

const GoogleMap = ({ singleMarker = false, coordinates, afterClick, afterClear, withActions = false }: IGoogleMapProps) => {
  const { T, toggleModal } = useUI()

  const [clicks, setClicks] = useState<Partial<google.maps.LatLng>[]>([])
  const [zoom, setZoom] = useState(15) // initial zoom
  const [center, setCenter] = useState<any>(TBILISI_COORDINATES)

  const onClick = (e: google.maps.MapMouseEvent, map: google.maps.Map) => {
    setZoom(map.getZoom() as number)
    setCenter({ lat: e.latLng?.lat(), lng: e.latLng?.lng() })

    let updatedClicks = []
    if(singleMarker) {
      updatedClicks = [e.latLng!]
    } else {
      updatedClicks = [...clicks, e.latLng!]
    }

    setClicks(updatedClicks)

    if(afterClick) {
      afterClick(e.latLng!)
    }
  }

  const clearMarkers = () => {
    setClicks([])
    if(afterClear) afterClear()
  }

  useEffect(()=>{
    if(coordinates) {
      setClicks([coordinates])
      setCenter(coordinates)
    }
  },[coordinates])

  return (
    <Box
      position="relative"
      padding="10px"
    >
      <Wrapper
        apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string}
        libraries={["places"]}
      >
        <Map
          style={{ width: "100%", height: "450px" }}
          center={center}
          zoomControl={true}
          zoom={zoom}
          isFractionalZoomEnabled={true}
          onClick={onClick}
        >
          {clicks.map((latLng: any, i: number) => (
            <Marker key={i} position={latLng} />
          ))}
        </Map>
      </Wrapper>
      {withActions && (
          <Flex mt="10px" justifyContent="space-between">
            <Button
                text={T("general.map.remove_marker")}
                onClick={clearMarkers}
                isDisabled={clicks.length === 0}
                variant="solid"
            />
            <Button
                text={T("actions.confirm")}
                onClick={() => toggleModal("googleMapModal", false)}
            />
          </Flex>
      )}
    </Box>
  )
}

export default GoogleMap
